import { Network, OnRampAsset, OnRampMethod, OnRampProvider } from '@usecapsule/core-sdk';
export const CAPSULE_CONNECT = 'https://connect.usecapsule.com/';
export const CAPSULE_TERMS_AND_CONDITIONS = 'https://capsule-org.notion.site/Terms-and-Conditions-d4a23d32c6a64acba9cec29a11cc09e9';
export const ON_RAMP_PROVIDERS = {
    [OnRampProvider.STRIPE]: {
        name: 'Stripe',
        feeLower: 0.99,
        feeUpper: 4.49,
        methods: [OnRampMethod.ACH, OnRampMethod.DEBIT, OnRampMethod.CREDIT],
        icon: 'stripeBrand',
        backgroundColors: ['#6772E5', '#808AF4'],
    },
    [OnRampProvider.RAMP]: {
        name: 'Ramp',
        feeLower: 0.99,
        feeUpper: 4.49,
        methods: [OnRampMethod.ACH, OnRampMethod.DEBIT, OnRampMethod.CREDIT],
        icon: 'rampNetworkBrand',
        backgroundColors: ['#21BF73', '#3AE492'],
    },
    [OnRampProvider.MOONPAY]: {
        name: 'MoonPay',
        feeLower: 1.0,
        feeUpper: 4.5,
        methods: [OnRampMethod.ACH, OnRampMethod.DEBIT, OnRampMethod.CREDIT],
        icon: 'moonpayBrand',
        backgroundColors: ['#7715F5', '#9647fd'],
    },
};
export const NETWORKS = {
    [Network.ETHEREUM]: { name: 'Ethereum', icon: 'ethereum' },
    [Network.SEPOLIA]: { name: 'Sepolia', icon: 'ethereum' },
    [Network.ARBITRUM]: { name: 'Arbitrum', icon: 'arbitrumBrand' },
    [Network.BASE]: { name: 'Base', icon: 'baseBrand' },
    [Network.OPTIMISM]: { name: 'Optimism', icon: 'optimismBrand' },
    [Network.POLYGON]: { name: 'Polygon', icon: 'polygonBrand' },
    [Network.SOLANA]: { name: 'Solana', icon: 'solana' },
    [Network.COSMOS]: { name: 'Cosmos', icon: 'cosmos' },
    [Network.CELO]: { name: 'Celo', icon: 'celoBrand' },
};
export const ON_RAMP_ASSETS = {
    [OnRampAsset.ETHEREUM]: { name: 'Ethereum', code: 'ETH', icon: 'ethereum' },
    [OnRampAsset.USDC]: { name: 'USDC', code: 'USDC', icon: 'usdcBrand' },
    [OnRampAsset.POLYGON]: { name: 'Polygon', code: 'MATIC', icon: 'polygonBrand' },
    [OnRampAsset.SOLANA]: { name: 'Solana', code: 'SOL', icon: 'solana' },
    [OnRampAsset.ATOM]: { name: 'Atom', code: 'ATOM', icon: 'cosmos' },
    [OnRampAsset.CELO]: { name: 'Celo', code: 'CELO', icon: 'celoBrand' },
    [OnRampAsset.TETHER]: { name: 'Tether', code: 'USDT', icon: 'tetherBrand' },
    [OnRampAsset.CUSD]: { name: 'Celo Dollar', code: 'CUSD', icon: 'celoBrand' },
    [OnRampAsset.CEUR]: { name: 'Celo Euro', code: 'CEUR', icon: 'celoBrand' },
    [OnRampAsset.CREAL]: { name: 'Celo Real', code: 'CREAL', icon: 'celoBrand' },
};
export function getNetworkName(str) {
    var _a, _b;
    return (_b = (_a = NETWORKS[str]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : `${str[0]}${str.slice(1).toLowerCase()}`;
}
export function getNetworkIcon(str) {
    var _a, _b;
    return (_b = (_a = NETWORKS[str]) === null || _a === void 0 ? void 0 : _a.icon) !== null && _b !== void 0 ? _b : 'globe';
}
export function getAssetName(str) {
    var _a, _b;
    return (_b = (_a = ON_RAMP_ASSETS[str]) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : str;
}
export function getAssetIcon(str) {
    var _a, _b;
    return (_b = (_a = ON_RAMP_ASSETS[str]) === null || _a === void 0 ? void 0 : _a.icon) !== null && _b !== void 0 ? _b : 'emptyCircle';
}
export const MOBILE_SIZE = 480;
export const NETWORK_NOT_SUPPORTED_ERROR = 'network not supported';
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const BODY_MOTION_VARIANTS = {
    enter: (direction) => {
        return {
            scale: direction > 0 ? 0.9 : 1.1,
            opacity: 0,
        };
    },
    center: {
        scale: 1,
        opacity: 1,
    },
    exit: (direction) => {
        return {
            scale: direction < 0 ? 0.9 : 1.1,
            opacity: 0,
        };
    },
};
export const BODY_TRANSITION = {
    duration: 0.2,
};
